import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import DatePicker from "react-datepicker";
import { registerLocale, setDefaultLocale } from  "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import uk from 'date-fns/locale/uk';
import { formatDateForCalendar } from '../actions/helpers'

import { setRemovedTokenSearchUri, setRemovedTokenSearchRemovedDateNotBefore, setRemovedTokenSearchRemovedDateNotAfter, setRemovedTokenSearchOwnerId, setRemovedTokenSearchRemovingInitiatorId,
		 setRemovedTokenSearchOperator, clearAllRemovedTokenSearchFields } from '../actions/localStates'

import i18next from 'i18next'

import calenderIcon from '../img/calendar.svg'

registerLocale('uk', uk)
setDefaultLocale('uk')

class RemovedTokenSearchView extends Component {

	constructor(props) {
	    super(props);
	    this.state = {
	    	removingDateTimeNotBefore: this.props.actions.formatDateForCalendar(this.props.search.removingDateTimeNotBefore) || "",
	    	removingDateTimeNotAfter: this.props.actions.formatDateForCalendar(this.props.search.removingDateTimeNotAfter) || ""
	    }

	    this.removingDateTimeNotBefore = React.createRef();
	    this.removingDateTimeNotAfter = React.createRef();

	    this.onUriChanged = this.onUriChanged.bind(this);
	    this.onOperatorChanged = this.onOperatorChanged.bind(this);
	    this.onOwnerIdChanged = this.onOwnerIdChanged.bind(this);
		this.onRemovingInitiatorIdChanged = this.onRemovingInitiatorIdChanged.bind(this);


	    this.onRemovingDateTimeNotBeforeChanged = this.onRemovingDateTimeNotBeforeChanged.bind(this);
		this.onRemovingDateTimeNotAfterChanged = this.onRemovingDateTimeNotAfterChanged.bind(this);

		this.clearForm = this.clearForm.bind(this);

		this.handleSearchKeyUp = this.keyUpHandler.bind(this, 'Search');

	}

	onUriChanged (e) {
		this.props.actions.setRemovedTokenSearchUri(e.target.value);
	}

	onOperatorChanged (e) {
		this.props.actions.setRemovedTokenSearchOperator(e.target.value);
	}

	onOwnerIdChanged (e) {
		this.props.actions.setRemovedTokenSearchOwnerId(e.target.value);
	}

	onRemovingInitiatorIdChanged (e) {
		this.props.actions.setRemovedTokenSearchRemovingInitiatorId(e.target.value);
	}

	onRemovingDateTimeNotBeforeChanged (d) {
        this.props.actions.setRemovedTokenSearchRemovedDateNotBefore(d)
        this.setState({removingDateTimeNotBefore: d})
    }

    onRemovingDateTimeNotAfterChanged (d) {
        this.props.actions.setRemovedTokenSearchRemovedDateNotAfter(d)
        this.setState({removingDateTimeNotAfter: d})
    }

	keyUpHandler(refName, e) {
        if (e.keyCode === 13) {
    		document.getElementById("search").click();
       		document.activeElement.blur()
        }
    }

	clearForm () {
		this.props.actions.clearAllRemovedTokenSearchFields();
		this.setState({removingDateTimeNotBefore: ""});
		this.setState({removingDateTimeNotAfter: ""});
		
		this.props.refresh();
	}

	componentDidMount() {

	}

	render() {
		return (
			<div>
				<div className="searh-bar-max-height" style={{marginBottom: "10px"}}>
					<div className="row col-lg-12 col-md-12 col-sm-12 col-xs-12" style={{padding: "0px"}}>
						<div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
							<label className="col-12 col-form-label" style={{fontSize: "15px", color: "#b5b1af", paddingBottom: "0px", paddingLeft: "0px"}}>{i18next.t("tokenUri")}</label>
							<input className="form-control" type="text" value={this.props.search.uri !== null ? this.props.search.uri : ""} onChange={this.onUriChanged} onKeyUp={this.handleSearchKeyUp} ref="Search" />
						</div>

						<div className="row col-lg-6 col-md-6 col-sm-6 col-xs-12">
		                    {/*<label className="col-lg-12 col-md-12 col-xs-12 col-sm-12 no-right-padding col-form-label" style={{fontSize: "15px", color: "#b5b1af", paddingBottom: "0px"}}>{i18next.t("trashOutDateTimeNotBefore")}</label>*/}
		                    <label className="col-12 col-form-label" style={{fontSize: "15px", color: "#b5b1af", paddingBottom: "0px", paddingLeft: "0px"}}>{i18next.t("ownerId")}</label>
							<input className="form-control" type="text" value={this.props.search.ownerId !== null ? this.props.search.ownerId : ""} onChange={this.onOwnerIdChanged} onKeyUp={this.handleSearchKeyUp} ref="Search" />
		                </div>
						{/*<div className="col-lg-4 col-md-4 col-sm-12 col-xs-12 padding-left">
							<label className="col-12 col-form-label" style={{fontSize: "15px", color: "#b5b1af", paddingBottom: "0px", paddingLeft: "0px"}}>{i18next.t("operator")}</label>
							<input className="form-control" type="text" value={this.props.search.operator !== null ? this.props.search.operator : ""} onChange={this.onOperatorChanged} onKeyUp={this.handleSearchKeyUp} ref="Search" />
						</div>*/}
						<div className="row col-lg-3 col-md-3 col-sm-6 col-xs-12" style={{padding: "0px"}}>
		                    <label className="col-lg-12 col-md-12 col-xs-12 col-sm-12 no-right-padding col-form-label" style={{fontSize: "15px", color: "#b5b1af", paddingBottom: "0px"}}>{i18next.t("removingDateTimeNotBefore")}</label>
		                    <div className="row col-lg-12 col-md-12 col-xs-12 col-sm-12 no-right-padding">
		                        
		                        <div className="col-11 no-left-right-margin">
		                            <div className="customDatePickerWidth">
		                            <DatePicker ref={this.removingDateTimeNotBefore} dateFormat="dd.MM.yyyy" maxDate={new Date()} className="form-control pointer" onClick={() => {this.removingDateTimeNotBefore.current.setOpen(true)}}
		                                selected={this.state.removingDateTimeNotBefore}
		                                onChange={this.onRemovingDateTimeNotBeforeChanged} />
		                            </div>
		                        </div>
		                        <div className="col-1 no-left-right-margin">
		                            <img className="img" onClick={() => {this.removingDateTimeNotBefore.current.setOpen(true)}} style={{cursor: "pointer"}}width="50px" height="40px" src={calenderIcon} alt="calenderIcon" />
		                        </div>

		                    </div>
		                </div>
		                <div className="row col-lg-3 col-md-3 col-sm-6 col-xs-12" style={{padding: "0px"}}>
		                    <label className="col-lg-12 col-md-12 col-xs-12 col-sm-12 no-right-padding col-form-label" style={{fontSize: "15px", color: "#b5b1af", paddingBottom: "0px"}}>{i18next.t("removingDateTimeNotAfter")}</label>
		                    <div className="row col-lg-12 col-md-12 col-xs-12 col-sm-12 no-right-padding">
		                        
		                        <div className="col-11 no-left-right-margin">
		                            <div className="customDatePickerWidth">
		                            <DatePicker ref={this.removingDateTimeNotAfter} dateFormat="dd.MM.yyyy" maxDate={new Date()} className="form-control pointer" onClick={() => {this.removingDateTimeNotAfter.current.setOpen(true)}}
		                                selected={this.state.removingDateTimeNotAfter}
		                                onChange={this.onRemovingDateTimeNotAfterChanged} />
		                            </div>
		                        </div>
		                        <div className="col-1 no-left-right-margin">
		                            <img className="img" onClick={() => {this.removingDateTimeNotAfter.current.setOpen(true)}} style={{cursor: "pointer"}}width="50px" height="40px" src={calenderIcon} alt="calenderIcon" />
		                        </div>

		                    </div>
		                </div>
		                
		                <div className="row col-lg-6 col-md-6 col-sm-6 col-xs-12">
		                    {/*<label className="col-lg-12 col-md-12 col-xs-12 col-sm-12 no-right-padding col-form-label" style={{fontSize: "15px", color: "#b5b1af", paddingBottom: "0px"}}>{i18next.t("trashOutDateTimeNotAfter")}</label>*/}
		                    <label className="col-12 col-form-label" style={{fontSize: "15px", color: "#b5b1af", paddingBottom: "0px", paddingLeft: "0px"}}>{i18next.t("removingInitiatorId")}</label>
							<input className="form-control" type="text" value={this.props.search.removingInitiatorId !== null ? this.props.search.removingInitiatorId : ""} onChange={this.onRemovingInitiatorIdChanged} onKeyUp={this.handleSearchKeyUp} ref="Search" />
		                </div>
		                	{/*<div className="row col-lg-4 col-md-4 col-sm-6 col-xs-12">
			                    <label className="col-lg-12 col-md-12 col-xs-12 col-sm-12 no-right-padding col-form-label" style={{fontSize: "15px", color: "#b5b1af", paddingBottom: "0px"}}>{i18next.t("trashOutDateTimeNotAfter")}</label>
			                    <label className="col-12 col-form-label" style={{fontSize: "15px", color: "#b5b1af", paddingBottom: "0px", paddingLeft: "0px"}}>{i18next.t("operator")}</label>
								<input className="form-control" type="text" value={this.props.search.operator !== null ? this.props.search.operator : ""} onChange={this.onOperatorChanged} onKeyUp={this.handleSearchKeyUp} ref="Search" />
			                </div>*/}


					</div>
					<div className="row col-lg-12 col-md-12 col-sm-12 col-xs-12" style={{padding: "0px"}}>
						
					</div>
				</div>
				<button className="btn btn-outline-info" style={{marginTop: "10xp", marginLeft: "10px", marginRight: "15px", marginBottom: "10px", float: "right"}} onClick={this.clearForm}>{i18next.t("cleanUpLabel")}</button>
				<button id="search" className="btn btn-info" style={{marginTop: "10xp", marginLeft: "10px", marginRight: "0px", marginBottom: "10px", float: "right"}} onClick={this.props.searchToken}>{i18next.t("searchLabel")}</button>
			</div>
		);
	}
}

function mapStateToProps(state) {
    return {
        base: state.base,
        search: state.removedTokenSearchReducer
    }
}

const mapDispatchToProps = (dispatch) => {
    const actions = {
	    formatDateForCalendar, setRemovedTokenSearchUri, 
	    setRemovedTokenSearchRemovedDateNotBefore, setRemovedTokenSearchRemovedDateNotAfter,
	    setRemovedTokenSearchOwnerId, setRemovedTokenSearchRemovingInitiatorId,
	    setRemovedTokenSearchOperator, clearAllRemovedTokenSearchFields
    };
    return {
       actions: bindActionCreators(actions, dispatch)
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(RemovedTokenSearchView);